import React from "react";
import { Link } from "react-router-dom";

/**
 * EmptyState. replaces every "No data yet" message across the app.
 *
 * Design-audit requirement: empty states do real onboarding work, not just
 * report absence. Always pair an empathetic line with a clear next action.
 *
 * Props:
 * icon (lucide-react component). rendered at 36px, navy with low opacity
 * title (string). short, warm, NEVER "No X yet"
 * description (string). one-sentence empathetic reason + value
 * actionLabel (string?). optional CTA button text
 * actionTo (string?). react-router link target
 * onAction (fn?). onClick handler (alternative to actionTo)
 * testid (string?). root data-testid
 */
export default function EmptyState({
 icon: Icon, title, description, actionLabel, actionTo, onAction, testid,
 secondary,
}) {
 return (
 <div className="card text-center py-12 px-6" data-testid={testid}>
 {Icon && (
 <div className="flex justify-center mb-4 opacity-40">
 <Icon size={40} strokeWidth={1.25} className="text-[#0D2B52]" />
 </div>
 )}
 <h3 className="font-serif text-xl text-[#0D2B52] mb-2">{title}</h3>
 <p className="text-[13px] text-[#5a6b7a] leading-relaxed max-w-sm mx-auto mb-5">
 {description}
 </p>
 {actionLabel && (actionTo ? (
 <Link
 to={actionTo}
 className="btn-teal inline-flex items-center gap-1.5 text-sm tap-target px-5"
 data-testid={testid ? `${testid}-cta` : undefined}
 >
 {actionLabel}
 </Link>
 ) : (
 <button
 onClick={onAction}
 className="btn-teal inline-flex items-center gap-1.5 text-sm tap-target px-5"
 data-testid={testid ? `${testid}-cta` : undefined}
 >
 {actionLabel}
 </button>
 ))}
 {secondary && (
 <div className="mt-3 text-[12px] text-[#9CA3AF]">{secondary}</div>
 )}
 </div>
 );
}
